import { ManagementApiService } from 'src/app/services';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import { profileContactModel } from 'src/app/Modules/management/models/organization/organization.model';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { FullUserData } from 'src/app/Modules/management/models/organization/fullUserData.model';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { takeUntil } from 'rxjs/operators';
import { InstanceForDashboard } from 'src/app/Modules/management/models/instance/instance.model';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-user-profile-wizard',
    templateUrl: './user-profile-wizard.component.html',
    styleUrls: ['./user-profile-wizard.component.scss'],
})
export class UserProfileWizardComponent implements OnInit {
    @Input() dataSource: any[];
    @Output() editProfileFormEmitter: EventEmitter<any> = new EventEmitter();
    @ViewChild(MatTabGroup) tabGroup: MatTabGroup;
    destroy$ = new Subject();
    profileDetails: profileContactModel;
    instances: InstanceForDashboard[];
    isPersonalTabVisible: boolean = true;
    isEmailNotificationVisible: boolean = true;
    getEmailandNotifications: any;
    securityRoleName: string;
    isCommunicationTab: boolean;
    generalTabIndex: number;
    proImg: string;
    editProfileForm: UntypedFormGroup;
    UserData: FullUserData;
    profileSettingAreaId: string;
    index: number;

    constructor(
        private user_utility: UserUtilityService,
        private globalEmittersService: GlobalEmittersService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private managementApiService: ManagementApiService,
        private formBuilder: UntypedFormBuilder,
        private activatedRoute: ActivatedRoute,
        private router: Router
    ) {
        this.isCommunicationTab = false;
        this.UserData = this.user_utility.userData;
    }

    async ngOnInit(): Promise<void> {
        this.activatedRoute.queryParams.subscribe((params) => {
            if (params) {
                this.index = +params['index'] || 0;
                if (this.index < 0 || this.index >= 3) {
                    this.index = 0;
                }
            }
        });

        this.editProfileForm = this.formBuilder.group({
            emailNotification: new UntypedFormGroup({}),
        });
        await this.getInstanceList();
        this.editProfileFormEmitter.emit(this.editProfileForm);

        this.isPersonalTabVisible = await this.user_utility.checkUserPermissionDataAndRoute('profile-personal-setting', userActions.View);

        this.isEmailNotificationVisible = await this.user_utility.checkUserPermissionDataAndRoute('profile-email-notification-setting', userActions.View);
        // if (this.isEmailNotificationVisible) {
        //     this.getEmailAndNoti();
        // }

        if (this.user_utility.userData?.isSysAdmin) {
            this.isCommunicationTab = true;
        }

        this.globalEmittersService.profileDetails.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            if (res) {
                if (res.isSysAdmin) {
                    this.isCommunicationTab = true;
                }
            }
        });
    }

    // getEmailAndNoti() {
    //     this.ngxUiLoaderService.start();
    //     this.managementApiService.getSettingProfileAreaId('userprofile').subscribe(
    //         (res) => {
    //             if (res.success === true) {
    //                 this.profileSettingAreaId = res.response.settingAreaId;
    //                 if (this.profileSettingAreaId) {
    //                     this.managementApiService.getSettingbySettinfAreaId(this.profileSettingAreaId).subscribe((resp) => {
    //                         if (resp.success === true) {
    //                             this.getEmailandNotifications = resp.response;

    //                             this.ngxUiLoaderService.stop();
    //                         } else {
    //                             this.ngxUiLoaderService.stop();
    //                         }
    //                     });
    //                 }
    //             } else {
    //                 this.ngxUiLoaderService.stop();
    //             }
    //         },
    //         (err) => {
    //             this.ngxUiLoaderService.stop();
    //         }
    //     );
    // }

    // * get instance list for current user
    async getInstanceList() {
        this.instances = [];
        let res = await this.managementApiService.getInstanceByOrgId(this.UserData.organisation.organisationId).toPromise();
        if (res.success) {
            this.tabGroup.selectedIndex = this.index;
            if (this.UserData?.organisations) {
                let userOrg = this.UserData?.organisations?.find((item) => item.organisationId == this.UserData.organisation.organisationId);
                userOrg?.instances?.forEach((instance) => {
                    let currentInstance = res.response.find((item) => item.instanceId == instance.instanceId);
                    if (instance.notes != null) {
                        currentInstance.notes = instance.notes;
                    }
                    if (currentInstance != null) {
                        this.instances.push(currentInstance);
                    }
                });
            }
        } else if (res.isCustom) {
            this.user_utility.errorModelPopup(res.message);
        }
    }

    onTabChange(event: MatTabChangeEvent): void {
        // Update the URL with the new index

        this.router.navigate([], {
            relativeTo: this.activatedRoute,
            queryParams: { index: event.tab.ariaLabel || 0 },
            queryParamsHandling: 'merge', // Merge with other existing query params
        });
    }
}
